export enum ImportTypes {
  'upsert' = 'upsert',
  'replace' = 'replace',
}
